import React from 'react';
import { InfoButtonStyled, InfoTextStyled, InfoSectionStyled } from './styled';

export const InfoSection: React.FC = () => {
  return (
    <InfoSectionStyled>
      <InfoButtonStyled />
      <InfoTextStyled>
        Check below to see if any documents are required for collection. If documents are required, select “UPLOAD
        DOCUMENT” and specify which document you are uploading. If the document is optional and you do not want to
        upload it, click &quot;Bypass&quot; under &quot;MORE OPTIONS&quot;. If no documents are required or you have
        uploaded all required documents – mark this step as “COMPLETE” at the bottom of the page.
      </InfoTextStyled>
    </InfoSectionStyled>
  );
};
